import { ThemeProvider, createTheme } from "@mui/material";
import { FC } from "react";

const theme = createTheme({});

export const MuiThemeProvider: FC<
  React.PropsWithChildren<React.PropsWithChildren<unknown>>
> = ({ children }) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;
